import { render } from "./EventPrc5.vue?vue&type=template&id=abe6afb6&scoped=true"
import script from "./EventPrc5.vue?vue&type=script&lang=js"
export * from "./EventPrc5.vue?vue&type=script&lang=js"

import "./EventPrc5.vue?vue&type=style&index=0&id=abe6afb6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe6afb6"]])

export default __exports__